import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { clearAdminToken } from "./utils/adminAuth";
import "./index.css";
import ChatInterface from "./components/ChatInterface";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./components/AdminLogin";
import RequireAdmin from "./components/RequireAdmin";

// Client Route Component (for end-users)
function ClientRoute() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center py-4">
            <h1 className="text-2xl font-bold text-gray-900">
              Student CRM Navigation Bot
            </h1>
          </div>
        </div>
      </div>

      {/* Chat Interface */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ChatInterface />
      </div>
    </div>
  );
}

// Admin Route Component (for administrators)
function AdminRoute() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSignOut = () => {
    clearAdminToken();
    navigate("/admin/login?next=" + encodeURIComponent(location.pathname));
  };

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Header */}
      <div
        className="shadow-sm border-b"
        style={{ background: "linear-gradient(135deg,#bc1900 0%,#7f0f2e 100%)" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <h1 className="text-2xl font-bold text-white">
              Student CRM Navigation Bot - Admin
            </h1>

            {/* Tab Navigation */}
            <div className="flex space-x-1 bg-white/15 p-1 rounded-lg">
              <Link
                to="/admin"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === "/admin"
                    ? "bg-white text-red-700 shadow-sm"
                    : "text-white/80 hover:text-white"
                }`}
              >
                Chat Interface
              </Link>
              <Link
                to="/admin/panel"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === "/admin/panel"
                    ? "bg-white text-red-700 shadow-sm"
                    : "text-white/80 hover:text-white"
                }`}
              >
                Admin Panel
              </Link>
              <a
                href="/admin/analysis_dashboard/"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname.startsWith("/admin/analysis_dashboard")
                    ? "bg-white text-red-700 shadow-sm"
                    : "text-white/80 hover:text-white"
                }`}
              >
                Analytics
              </a>
              <button
                type="button"
                onClick={handleSignOut}
                className="px-4 py-2 rounded-md text-sm font-medium text-white/90 hover:text-white"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/" element={<ChatInterface />} />
          <Route path="/panel" element={<AdminPanel />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<ClientRoute />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <RequireAdmin>
              <AdminRoute />
            </RequireAdmin>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
